import React, { type CSSProperties } from 'react';

import { cn } from '../../utils/cn';

interface SpacingProps {
  size: CSSProperties['height'];
  className?: string;
}

/**
 * Spacing component for adding vertical spacing between elements
 *
 * @param size - The spacing size (semantic or numeric)
 * @param className - Additional CSS classes
 */
export const Spacer: React.FC<SpacingProps> = ({ size, className }) => {
  return (
    <div className={cn('w-full shrink-0', className)} aria-hidden="true" style={{ height: size }} />
  );
};
